<template>
	<div :class="$style.notification">
		<BaseTooltip
			v-if="notification.timestamp"
			position="right"
			:content="date"
		>
			<TimeAgo
				:class="[$style['color'],$style['color--grey']]"
				:timestamp="timestamp"
			/>
		</BaseTooltip>
		<p :class="$style['notification__title']" class="notification__title">
			{{ $t('notifications.types.create-grouped-sale-parts-from-draft.title') }}
		</p>
		<p
			v-if="statusText"
			:class="$style['notification__notice']"
		>
			{{ statusText }}
		</p>
	</div>
</template>

<script>
import moment from '@/packages/moment'
import TimeAgo from '@/components/Essentials/TimeAgo'
import { normalizeCreateFromDraftResults } from '@/views/Dashboard/GroupedSaleDraft/components/utils'
export default {
	name: 'CreateGroupedSalePartsFromDraftNotification',
	components: {
		TimeAgo
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	computed: {
		results () {
			return normalizeCreateFromDraftResults(this.notification?.results)
		},
		isError () {
			return this.notification?.__typename === 'ErrorEvent' || this.results.state === 'failed'
		},
		statusText () {
			if (this.isError) {
				return this.$t('notifications.types.create-grouped-sale-parts-from-draft.error', {
					message: this.notification?.error?.message || this.results.error?.message || ''
				})
			}
			if (this.results.state === 'completed') {
				return this.$t('notifications.types.create-grouped-sale-parts-from-draft.completed', {
					created: this.results.createdParts,
					total: this.results.totalParts
				})
			}
			return null
		},
		date () {
			if (this.notification.timestamp) {
				return moment(this.notification.timestamp).format('LLLL')
			}
			return null
		},
		timestamp () {
			if (this.notification.timestamp) {
				return new Date(this.notification.timestamp).getTime()
			}
			return null
		}
	}
}
</script>

<style lang="scss" module>
.color {
    font-size: 12px;

    &--grey {
        color: getColor(caption);
    }
}

.notification {
    font-size: 14px;

    &__title {
        margin: 0;
        font-size: 16px;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    &__notice {
        margin: 0;
        margin-bottom: 10px;
        font-size: 14px;
    }
}
</style>
